import {Component, Input, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {
  PdfToolbarService
} from "@components/shared/document-viewer/pdf-toolbar/pdf-toolbar.service";

@Component({
    selector: 'app-pdf-zoom',
    templateUrl: './pdf-zoom.component.html',
    styleUrls: ['./pdf-zoom.component.scss'],
    standalone: false
})
export class PdfZoomComponent implements OnInit {
  @Input() zoomElementContainerId: string;
  protected imageScale$: Observable<number>;
  MATH = Math;

  constructor(
    public pdfToolbarService: PdfToolbarService
  ) {
    this.imageScale$ = pdfToolbarService.imageScale$;
  }

  ngOnInit() {
    this.pdfToolbarService.imageScale$.subscribe((imageScale) => {
      const zoomTargetEl = document.getElementById(this.zoomElementContainerId);
      if (isNaN(imageScale) || !zoomTargetEl) {
        return
      }
      zoomTargetEl.style.transform = 'scale(' + imageScale + ')';
      const scaleOffset = imageScale - 1;
      zoomTargetEl.style.marginBottom = `${zoomTargetEl.offsetHeight * scaleOffset}px`;
      zoomTargetEl.style.marginRight = `${zoomTargetEl.offsetWidth * scaleOffset}px`;
    })
  }

  zoomIn() {
    this.pdfToolbarService.zoomIn();
  }

  zoomOut() {
    this.pdfToolbarService.zoomOut();
  }

}
